import { Directive, Input } from "@angular/core";
import { NgControl } from "@angular/forms";

/**
 * Direttiva di comodo per disabilitare gli input gestiti con ReactiveForms; agisce sul form control collegato
 * ```
 * <input [disableControl]="true" [FormControl]="myControl">
 * <input [disableControl]="expression" formControlName="myOtherControl">
 * ```
 */
@Directive({
    selector: '[disableControl]'
})
export class DisableControlDirective {

    @Input() set disableControl(condition: boolean) {
        const action = condition ? 'disable' : 'enable';
        this.ngControl.control[action]();
    }

    constructor(private ngControl: NgControl) {
    }

}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/directives/disable-control.directive.ts